import { z } from "zod";
import { plainTextField } from "./public-api.js";
export const createSiteGroupSchema = z.object({
    name: plainTextField(120),
    description: plainTextField(500).optional().default(""),
    siteIds: z.array(z.string().min(1)).optional().default([]),
});
export const updateSiteGroupSchema = createSiteGroupSchema.partial().extend({
    active: z.boolean().optional(),
});
//# sourceMappingURL=site-groups.js.map